export class WhatsAppOfficialAtendimento {
  public id: number;
  public guidclientenapis: string;
  public telefone: string;
  public telefone_normalizado: string;
  public wa_contact_id: string;
  public contato_nome: string;
  public contato_callcenter?: string;
  public contato_foto_url: string;
  public whatsapp_oficial_etapa_id: number;
  public etapa_tipo: string;
  public seller_id_atual: number;
  public seller_id_sugerido: number;
  public seller_id_captura: number;
  public client_id: number;
  public client_name_snapshot: string;
  public client_codigo_erp_snapshot: string;
  public no_order_done_reason_id: number;
  public motivo_perda_complemento: string;
  public dt_primeira_mensagem: Date;
  public primeira_mensagem_direcao: string;
  public dt_ultima_mensagem: Date;
  public dt_ultima_mensagem_cliente: Date;
  public dt_captura: Date;
  public dt_inicio_atendimento: Date;
  public dt_finalizacao: Date;
  public ultima_mensagem_id: number;
  public ultima_mensagem_preview: string;
  public ultima_mensagem_direcao: string;
  public qtde_mensagens_nao_lidas: number;
  public is_ativo: boolean;
  public ia_modo_override: string;
  public ia_dt_ultima_resposta: Date;
  public ia_dt_handoff: Date;
  public created_at: Date;
  public updated_at: string;
  public etapa_nome: string;
  public etapa_cor_hex: string;
  public seller_nome_atual: string;
  public janela_24h_aberta: boolean;
  public is_uazapi: boolean;
  public ia_sugestao_pendente: boolean;
  public motivo_perda_nome: string;

  constructor() { }
}
